<!-- Link Expired Popup -->
<div [ngClass]="this.language == null || this.language === 'en' ? 'pre-login-en-css' : 'pre-login-other-css'">
  <div class="container-fluid link-expired">
    <div class="py-2">
      <img [src]="'IMAGES.LOGOIMG'|translate" width="120" alt="" />
    </div>
    <div class="row my-5">
      <div class="col-12 text-center">
        <div class="bg-white p-3">
          <ng-container *ngIf="linkText === 'LIMIT_EXCEEDS'">
            <div class="mt-3">
              <img [src]="'SIGNUP.LIMITEXCEEDIMG'|translate" alt="" class="mx-auto limitexceedImg" />
            </div>
            <h5 class="mt-3 fw-bold">
              {{ "LINKEXPIRED.USERLIMITEXCEEDED" | translate }}
            </h5>
            <div class="mt-3">
              <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal" [routerLink]="['/']">
                {{ "LINKEXPIRED.DONE" | translate }}
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="linkText === 'URL_EXPIRED'">
            <div class="mt-3">
              <img [src]="'SIGNUP.LINKEXPIREDIMG'|translate" alt="" class="mx-auto limitexceedImg" />
            </div>
            <h5 class="my-3 fw-bold"> {{ "LINKEXPIRED.LINKEXPIRED" | translate }}</h5>
            <div class="mt-3">
              <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal" [routerLink]="['/']">
                {{ "LINKEXPIRED.DONE" | translate }}
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>